import { useLocation } from 'react-router-dom';
import { Commentable } from '@/shared/comments/Commentable';
import { Pill } from '@/design-system/Pill';
import {
  ADMIN_NAV_GROUP_ORDER,
  ADMIN_NAV_ITEMS,
} from '@/versions/v1/shared/admin-nav-seed';
import {
  SidebarRail,
  SidebarRailButton,
  SidebarRow,
  SidebarSection,
  SidebarShell,
} from './SidebarShell';
import { SidebarSceneHeader } from './SidebarSceneHeader';

function isActive(pathname: string, href: string): boolean {
  if (pathname === href) return true;
  return pathname.startsWith(`${href}/`);
}

export function AdminSidebar() {
  const { pathname } = useLocation();

  const grouped = ADMIN_NAV_GROUP_ORDER.map((group) => ({
    label: group,
    items: ADMIN_NAV_ITEMS.filter((item) => item.navGroup === group),
  }));

  return (
    <Commentable name="AdminSidebar">
      <SidebarShell
        ariaLabel="Admin navigation"
        collapsedRail={
          <SidebarRail>
            {ADMIN_NAV_ITEMS.map((item) => {
              const href = `/admin/${item.slug}`;
              return (
                <SidebarRailButton
                  key={item.id}
                  href={href}
                  icon={item.Icon}
                  label={item.navLabel}
                  isActive={isActive(pathname, href)}
                />
              );
            })}
          </SidebarRail>
        }
        header={
          <SidebarSceneHeader
            title="Admin"
            back={{ href: '/', label: 'Back to chats' }}
          />
        }
      >
        <nav aria-label="Admin sections">
          {grouped.map((group, gi) => (
            <SidebarSection key={group.label} label={group.label} first={gi === 0}>
              <ul className="space-y-0">
                {group.items.map((item) => {
                  const href = `/admin/${item.slug}`;
                  return (
                    <li key={item.id}>
                      <SidebarRow
                        href={href}
                        icon={item.Icon}
                        label={item.navLabel}
                        isActive={isActive(pathname, href)}
                        trailing={
                          item.badgeCount ? (
                            <Pill>
                              {item.badgeCount > 99 ? '99+' : item.badgeCount}
                            </Pill>
                          ) : undefined
                        }
                      />
                    </li>
                  );
                })}
              </ul>
            </SidebarSection>
          ))}
        </nav>
      </SidebarShell>
    </Commentable>
  );
}
